<template>
  <div class="delegation">
    <div class="header">
      <el-page-header @back="goBack" title="Home" content="Delegation Setting">
      </el-page-header>
    </div>
    <div class="body">
      <div class="form-wrapper">
        <el-form
          :model="form"
          size="small"
          status-icon
          :rules="rules"
          ref="form"
        >
          <el-row :gutter="24">
            <el-col :xs="24" :lg="12">
              <el-form-item label="Application" prop="application">
                <el-select
                  v-model="form.application"
                  placeholder="Select application"
                  style="width: 100%"
                  @change="onApplication"
                >
                  <el-option
                    v-for="(item, index) in app"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Delegation Date" prop="date">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.date"
                  type="daterange"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="From User" prop="userFrom">
                <el-select
                  :disabled="disabled"
                  v-model="form.userFrom"
                  filterable
                  placeholder="Select user"
                  style="width: 100%"
                >
                  <!-- :label="item.tlc + ' (' + item.nama + ')'" -->
                  <el-option
                    v-for="item in availableUser"
                    :key="item.tlc"
                    :value="item.tlc"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="To User" prop="userTo">
                <el-select
                  :disabled="disabled"
                  v-model="form.userTo"
                  filterable
                  placeholder="Select user delegation"
                  style="width: 100%"
                >
                  <!-- :label="item.tlc + ' (' + item.nama + ')'" -->
                  <el-option
                    v-for="item in userToList"
                    :key="item.tlc"
                    :value="item.tlc"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Note" prop="note">
                <el-input type="textarea" v-model="form.note"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="action">
          <el-button
            :loading="loading"
            @click="handleDelegation()"
            type="primary"
            :disabled="activeDelegation"
          >
            Set Delegation
          </el-button>
        </div>
      </div>
      <History />
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import History from "@/components/delegation/History.vue";
import { mapGetters } from "vuex";

export default {
  name: "delegation",
  components: { History },
  data() {
    const app = ["Semua Aplikasi", "Simfoni", "Harmoni", "Assist"];
    return {
      app,
      loading: false,
      form: {
        application: "",
        date: [],
        userFrom: "",
        userTo: "",
        note: "",
      },
      disabled: true,
      availableUser: [],
      userToList: [],
      rules: {
        application: [{ required: true, trigger: "change" }],
        date: [{ required: true, trigger: "change" }],
        userFrom: [{ required: true, trigger: "change" }],
        userTo: [{ required: true, trigger: "change" }],
        note: [{ required: true, trigger: "blur" }],
      },
      activeDelegation: false,
    };
  },
  computed: {
    ...mapGetters({
      activeUser: "getActiveUser",
      team: "getTeam",
      delegation: "getList",
    }),
  },
  watch: {
    "form.userTo"() {
      if (this.form.userTo !== "") {
        if (this.form.userFrom == this.form.userTo) {
          this.$notify.error({
            title: "Error",
            message: "Please select another user delegation!",
          });
          this.form.userTo = "";
        } else {
          this.checkDelegation(this.form.userTo, "to");
        }
      }
    },
    "form.userFrom"() {
      if (this.form.userFrom !== "") {
        if (this.form.userFrom == this.form.userTo) {
          this.$notify.error({
            title: "Error",
            message: "Please select another user from!",
          });
          this.form.userFrom = "";
        } else {
          this.checkDelegation(this.form.userFrom, "from");
        }
      }
    },
  },
  mounted() {
    this.fetch();
    this.startAnimation();
  },
  methods: {
    startAnimation() {
      gsap.from(".delegation", {
        y: -10,
        duration: 2,
        ease: "elastic",
      });
    },
    goBack() {
      this.$router.push({ name: "Home" });
    },
    fetch() {
      Promise.all([
        this.$store.dispatch("fetchList"),
        this.$store.dispatch("fetchTeam"),
      ]);
    },
    onApplication(app) {
      this.form.userFrom = "";
      this.form.userTo = "";
      let selected = false;
      let selectedTo = false;

      console.log(app)

      if (app == "Semua Aplikasi") {
        this.availableUser = this.team.filter((team) =>
          this.delegation.some((item) => {
            if (
              item.status == 1 &&
              item.tlc_asal !== team.tlc &&
              item.tlc_delegasi !== team.tlc
            ) {
              selected = true;
              return item;
            }
          })
        );

        this.userToList = this.team.filter((team) =>
          this.delegation.some((item) => {
            if (
              item.status == 1 && 
              item.tlc_asal !== team.tlc
            ) {
              selectedTo = true;
              return item;
            }
          })
        );
      } else {
        this.availableUser = this.team.filter((team) =>
          this.delegation.some((item) => {
            if (
              item.aplikasi == app &&
              item.status == 1 &&
              item.tlc_asal !== team.tlc &&
              item.tlc_delegasi !== team.tlc
            ) {
              selected = true;
              return item;
            }
          })
        );

        this.userToList = this.team.filter((team) =>
          this.delegation.some((item) => {
            if (
              item.aplikasi == app &&
              item.status == 1 && 
              item.tlc_asal !== team.tlc
            ) {
              selectedTo = true;
              return item;
            }
          })
        );
      }

      if (!selected) {
        this.availableUser = this.team;
      }

      if(!selectedTo){
        this.userToList = this.team
      }

      this.disabled = false;
    },
    handleDelegation() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$notify.error({
            title: "Error",
            message: "Complete you form!",
          });

          return;
        }

        this.loading = true;
        const data = {
          ...this.form,
          start_dt: this.form.date[0],
          end_dt: this.form.date[1],
        };

        this.$store
          .dispatch("createDelegation", data)
          .then((res) => {
            this.fetch();
            this.$refs["form"].resetFields();
            this.loading = false;
            this.$notify.success({
              title: `Success`,
              message: `Delegation has been created!`,
            });
          })
          .catch((err) => {
            this.$notify.error({
              title: "Error",
              message: err.response.data.error,
            });
            this.loading = false;
          });
      });
    },
    checkDelegation(item, app) {
      this.activeDelegation = true;
      this.$store
        .dispatch("checkDelegation", {
          tlc: item,
          aplikasi: this.form.application,
        })
        .then((res) => {
          if (res[0].count > 0) {
            this.$notify.error({
              title: "Error",
              message: `(${item}) is currently active in another delegation. Please select another user`,
            });

            if (app == "to") {
              this.form.userTo = "";
            } else {
              this.form.userFrom = "";
            }
          }

          this.activeDelegation = false;
        })
        .then((err) => {
          this.$notify.error({
            title: "Error",
            message: err.response.data.error,
          });
          this.activeDelegation = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.delegation {
  background-color: white;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: auto;
  z-index: 1;
  .header {
    padding: $space;
    border-bottom: 1px solid darken(white, 5);
  }

  .body {
    display: flex;
    flex-direction: column;
    overflow: auto;
    background-color: darken(white, 2);
  }
}

.form-wrapper {
  padding: $space $space * 3;

  .action {
    padding: $space 0;
  }
}
</style>
